/**
 * Utility functions for portfolio comparison functionality
 */

export interface ComparisonPortfolioData {
    portfolioData1: any | null;
    portfolioData2: any | null;
    hasData: boolean;
}

/**
 * Create enriched comparison report parameters using v2 API
 * This combines two single portfolio parameters into a comparison structure
 */
export async function createComparisonReportParameters(
    fetchReportParameters: (portfolioId: string) => Promise<any>,
    portfolioId1: string,
    portfolioId2: string
): Promise<any> {
    // Get parameters for both portfolios
    const [params1, params2] = await Promise.all([
        fetchReportParameters(portfolioId1),
        fetchReportParameters(portfolioId2)
    ]);

    // Clone first portfolio's parameters as base
    const response = JSON.parse(JSON.stringify(params1));

    // Enable scheda_prodotti2 for comparison
    if (response.report_sections) {
        response.report_sections.scheda_prodotti2 = {
            ...response.report_sections.scheda_prodotti,
            visible: true,
            title: "Schede Prodotto (Portafoglio 2)"
        };
        response.report_sections.scheda_prodotti.title = "Schede Prodotto (Portafoglio 1)";

        // Add product entries from portfolio 2 to scheda_prodotti2
        if (params2.report_sections?.scheda_prodotti) {
            Object.keys(params2.report_sections.scheda_prodotti).forEach(key => {
                if (key.startsWith('product_')) {
                    response.report_sections.scheda_prodotti2[key] = params2.report_sections.scheda_prodotti[key];
                }
            });
        }
    }

    return response;
}

/**
 * Get filename for comparison PDF download
 */
export function getComparisonPdfFilename(portfolioId1: string, portfolioId2: string): string {
    return `portfolio-comparison-${portfolioId1}-${portfolioId2}.pdf`;
}
